exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, "h5[data-v-405affcc]{margin-top:10px;margin-left:auto;margin-right:auto;color:gray}p[data-v-405affcc]{margin-left:auto;margin-right:auto;text-align:center;font-size:.8em;color:#a9a9a9}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader?minimize!./~/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-405affcc","scoped":true,"hasInlineConfig":false}!./~/sass-loader/lib/loader.js!./~/vue-loader/lib/selector.js?type=styles&index=0!./src/components/WorkoutComponent.vue
// module id = 17
// module chunks = 0